<button type="button" [disabled]="!builder.addItemEnabled" (click)="openSelectLocaleDialog()">{{ 'translation.add.action.value' | translate }}</button>
